export interface ClaudeResponse {
  message: string;
  usedTokens: number;
}

export interface ClaudeStreamEvent {
  text?: string;
  type?: 'usage';
  usage?: {
    inputTokens: number;
    outputTokens: number;
    totalTokens: number;
  };
}

export async function sendStreamingMessage(
  response: any,
): Promise<{ message: string; usedTokens: number }> {
  try {
    const reader = response.body.getReader();
    const decoder = new TextDecoder();

    let message = '';
    let usage = {
      totalTokens: 0,
    };

    while (true) {
      const { value, done } = await reader.read();
      if (done) break;

      const chunk = decoder.decode(value);
      const lines = chunk.split('\n');

      for (const line of lines) {
        if (line.startsWith('data: ')) {
          const data = line.slice(6);
          if (data === '[DONE]') {
            break;
          }

          try {
            const parsed: ClaudeStreamEvent = JSON.parse(data);
            if (parsed.text) {
              message += parsed.text;
            } else if (parsed.type === 'usage') {
              usage.totalTokens = parsed.usage?.totalTokens || 0;
            }
          } catch (e) {
            console.error('Error parsing SSE data:', e);
          }
        }
      }
    }

    return { message, usedTokens: usage.totalTokens };
  } catch (error) {
    console.error('Error parsing SSE data:', error);
    throw error;
  }
}
